import { createReceiver } from './peerLink'
import { setMobileStream, clearMobileStream, getMobileStream } from './mobileStream'
import {
    setPhoneOrientation,
    resetPhoneOrientationReported,
} from '../vision/cameraConfig'

// Owns the desktop-side receiver link at MODULE scope so a paired phone camera
// survives navigation (Configure -> Execute) — the pairing UI in InputsPanel
// only drives it, it doesn't own it, so unmounting that panel won't drop the
// stream. Call stopMobilePairing() explicitly to disconnect.
let link = null
let room = ''
let statusCb = null

export function startMobilePairing(roomCode, onState) {
    stopMobilePairing()
    room = roomCode
    statusCb = onState || null
    resetPhoneOrientationReported()
    link = createReceiver(roomCode, {
        onStream: (stream) => {
            setMobileStream(stream)
            sessionStorage.setItem('aiMobileCam', 'true')
            if (statusCb) statusCb('connected', stream)
        },
        onState: (s) => statusCb && statusCb(s),
        onOrient: (o) => setPhoneOrientation(o),
    })
}

export function stopMobilePairing() {
    if (link) {
        try {
            link.close()
        } catch (e) {
            /* ignore */
        }
    }
    link = null
    room = ''
    statusCb = null
    resetPhoneOrientationReported()
    clearMobileStream()
    sessionStorage.removeItem('aiMobileCam')
}

export function mobilePairingActive() {
    return !!link
}
export function mobilePairingRoom() {
    return room
}
export function mobileConnected() {
    return !!getMobileStream()
}
// Re-point the status/stream callback (e.g. when the pairing UI remounts).
export function setPairingStatusCallback(cb) {
    statusCb = cb || null
}
